import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyPounds: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyPounds"><Path d="M5.5 20.5C10.543 20.5 8.70221 11.2922 8.70221 8.28125C8.70221 5.64064 10.8527 3.5 13.5055 3.5C15.1709 3.5 16.6383 4.34364 17.5 5.625" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 20.5H18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 12.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyPounds;
